export const companyValues = {
  advance: "12519",
  aeskins: "12507",
  medbank: "12503",
  medsystems: "12501",
  mosaic: "12505",
};

export const companyOriginValues = {
  advance: "12509",
  aeskins: "12511",
  medbank: "12515",
  medsystems: "12513",
  mosaic: "12517",
};

export const serviceTypeValues = {
  mensal: "8379",
  premiacao: "8381",
};

export const labelValues = {
  advance: "ADVANCE VISION",
  aeskins: "AESKINS",
  medbank: "MEDBANK",
  medsystems: "MEDSYSTEMS",
  mosaic: "MOSAIC",
  mensal: "Mensal",
  premiacao: "Premiação",
};
